import React from "react";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const MapSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="text-center">
        <h2 className="text-4xl font-extrabold mb-4 text-blue-900 leading-tight">
          {t("Our Location")}
        </h2>
        <p className="text-lg text-green-600 mb-6">
          {t("Visit us at our office or find us on the map below.")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="rounded-lg overflow-hidden shadow-lg border-2 border-green-600">
            <h3 className="text-2xl font-bold text-white bg-green-600 py-2">
              {t("Head Office")}
            </h3>
            {/* <iframe
                            title="Head Office"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2363.4396093335035!2d72.87570004301018!3d19.11980454164711!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9fb253c22df%3A0x7814bc5a036866d0!2sMena%20Support%20Service%20Limited!5e1!3m2!1sen!2sin!4v1741255503664!5m2!1sen!2sin"
                            className="w-full h-80"
                            allowFullScreen
                            loading="lazy"
                        ></iframe> */}
            <div className="rounded-lg overflow-hidden transition-shadow transform duration-300">
              <div className="p-6">
                <p className="text-sm sm:text-base text-gray-700 mb-4 flex items-start">
                  <FaMapMarkerAlt className="mr-2 text-blue-700 text-3xl" />
                  AIRAA Head Office, Mandakini, Jangid Complex Rd, Silver Park,
                  Mira Road East, Mumbai, Mira Bhayandar, Maharashtra 401107
                </p>
                <div className="mb-4">
                  <h3 className="text-md font-semibold text-blue-900">
                    Phone Numbers:
                  </h3>
                  <div className="space-y-2 text-sm sm:text-base text-gray-600">
                    <div className="flex justify-center items-center space-x-2">
                      <FaPhoneAlt className="text-blue-600" />
                      <a
                        href={`tel:+91 7738355865`}
                        className="text-blue-600 hover:underline"
                      >
                        +91 77383 55865
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-lg overflow-hidden shadow-lg border-2 border-green-600">
            <h3 className="text-2xl font-bold text-white bg-green-600 py-2">
              {t("Branch Office")}
            </h3>
            {/* <iframe
                            title="Branch Office"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d590.2880942211073!2d72.87176729326653!3d19.27911226935989!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b05cd00481c7%3A0x305bab345a2871ed!2sAsmacs%20Skill%20Development%20Limited!5e1!3m2!1sen!2sin!4v1741255725507!5m2!1sen!2sin"
                            className="w-full h-80"
                            allowFullScreen
                            loading="lazy"
                        >
                        </iframe> */}
            <div className="rounded-lg overflow-hidden transition-shadow transform duration-300">
              <div className="p-6">
                <p className="text-sm sm:text-base text-gray-700 mb-4 flex items-start">
                  <FaMapMarkerAlt className="mr-2 text-blue-700 text-2xl" />
                  AIRAA Branch Office, Office No. 14A, Options Primo, 21st Rd,
                  near passport Office, Shree Krishna Nagar, Marol MIDC Industry
                  Estate, Andheri East, Mumbai, Maharashtra 400093
                </p>
                <div className="mb-4">
                  <h3 className="text-md font-semibold text-blue-900 text-center">
                    Phone Numbers:
                  </h3>
                  <div className="space-y-2 text-sm sm:text-base text-gray-600">
                    <div className="flex justify-center items-center space-x-2">
                      <FaPhoneAlt className="text-blue-600" />
                      <a
                        href={`tel:+91 7738355865`}
                        className="text-blue-600 hover:underline"
                      >
                        +91 77383 55865
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MapSection;
